import { useState } from 'react';
import { Button, Radio, RadioGroup } from '@nextui-org/react';
import { Constants } from '../../../utils';

const statuses = [
  { value: Constants.PAYMENT.STATUS.PENDING.toString(), label: 'Por validar', disabled: false },
  { value: Constants.PAYMENT.STATUS.APPROVED.toString(), label: 'Aprobado', disabled: true },
  { value: Constants.PAYMENT.STATUS.REJECTED.toString(), label: 'Rechazado', disabled: true },
];

const PopStatus = ({ item, onSubmit }) => {
  const [form, setForm] = useState({
    id: item.id,
    status: String(item.status),
  });

  const onChange = (value, target) => {
    setForm(s => ({ ...s, [target]: value }));
  }

  const canSubmit = form.status !== String(item.status);
  const isMobilePayment = item.payment_method_id === Constants.PAYMENT.METHOD.MOBILE;

  return (
    <div className="py-2 space-y-4">
      <RadioGroup
        label="Selecciona el estatus"
        value={form.status}
        onValueChange={v => onChange(v, 'status')}
      >
        {statuses.map(item => (
          <Radio key={item.value} value={item.value} isDisabled={item.disabled}>{ item.label }</Radio>
        ))}
      </RadioGroup>

      <Button
        radius="sm"
        fullWidth
        color={canSubmit ? 'primary':'default'}
        isDisabled={isMobilePayment || !canSubmit}
        onClick={() => onSubmit(form)}
      >
        Guardar
      </Button>
    </div>
  )
}

export default PopStatus;